/**
 * Validates a value is equal or less than a given value.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {number} context.limit The maximum value
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name max
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  const res = value <= context.maxLimit;
  return Promise.resolve(res ? null : 'not-max');
}

module.exports = validate;